<template>
  <div class="riclothes-accordion">
    <transition name="riclothes-accordion" 
      @before-enter="beforeEnter" 
      @enter="enter"
      @before-leave="beforeLeave"
      @leave="leave">
      <slot v-if="isOpen"></slot>
    </transition>
  </div>
</template>

<script>
export default {
  name: "ri-clothes-accordion",
  props: {
    isOpen: {
      isOpen: Boolean,
      default: false
    }
  },

  methods: {
    beforeEnter(el) {
      el.style.height = '0';
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    beforeLeave: function(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    leave: function(el) {
      el.style.height = '0';
    }
  }
}
</script>

<style lang="scss" scoped>
.riclothes-accordion {
  overflow: hidden;
  &-enter-active, &-leave-active {
    transition: height 0.6s ease-in-out;
  }
}
</style>